import openPhotoSwipe from '../util/open-photoswipe';

const selectors = {
  zoomWrapper: '[data-zoom-wrapper]',
  dataImageSrc: 'data-image-src',
  dataImageWidth: 'data-image-width',
  dataImageHeight: 'data-image-height',
  dataImageZoomEnable: 'data-image-zoom-enable',
  thumbs: '.pswp__thumbs',
  caption: '[data-zoom-caption]',
};

const classes = {
  variantSoldOut: 'variant--soldout',
  variantUnavailable: 'variant--unavailabe',
  popupThumb: 'pswp__thumb',
  popupClass: 'pswp-zoom-gallery',
  popupClassNoThumbs: 'pswp-zoom-gallery--single',
};

class Zoom {
  constructor(section) {
    this.container = section.container;
    this.zoomWrappers = this.container.querySelectorAll(selectors.zoomWrapper);
    this.thumbsContainer = document.querySelector(selectors.thumbs);
    this.zoomCaptionElem = this.container.querySelector(selectors.caption);
    this.zoomEnable = this.container.getAttribute(selectors.dataImageZoomEnable) === 'true';

    if (this.zoomEnable) {
      this.init();
    }
  }

  init() {
    const self = this;

    if (this.zoomWrappers.length) {
      this.zoomWrappers.forEach((element, i) => {
        element.addEventListener('click', function (e) {
          e.preventDefault();

          self.createZoom(i);
        });

        element.addEventListener('keyup', function (e) {
          // On keypress Enter move the focus to the first focusable element in the related slide
          if (e.keyCode === 13) {
            e.preventDefault();

            self.createZoom(i);
          }
        });
      });
    }
  }

  createZoom(indexImage) {
    const self = this;
    let items = [];
    let counter = 0;
    let thumbs = '';
    this.zoomWrappers.forEach((elementImage) => {
      const imgSrc = elementImage.getAttribute(selectors.dataImageSrc);
      const imgWidth = parseInt(elementImage.getAttribute(selectors.dataImageWidth));
      const imgHeight = parseInt(elementImage.getAttribute(selectors.dataImageHeight));

      items.push({
        src: imgSrc,
        w: imgWidth,
        h: imgHeight,
        msrc: imgSrc,
      });

      thumbs += `<a href="#" class="${classes.popupThumb}" style="background-image: url('${imgSrc}')"></a>`;

      counter += 1;
      if (self.zoomWrappers.length === counter) {
        let popupClass = `${classes.popupClass}`;
        if (counter === 1) {
          popupClass = `${classes.popupClass} ${classes.popupClassNoThumbs}`;
        }
        const options = {
          history: false,
          focus: false,
          index: indexImage,
          mainClass: popupClass,
          showHideOpacity: true,
          howAnimationDuration: 150,
          hideAnimationDuration: 250,
          closeOnScroll: false,
          closeOnVerticalDrag: false,
          captionEl: true,
          closeEl: true,
          closeElClasses: ['caption-close'],
          tapToClose: false,
          clickToCloseNonZoomable: false,
          maxSpreadZoom: 2,
          loop: true,
          spacing: 0,
          allowPanToNext: true,
          pinchToClose: false,
          addCaptionHTMLFn: function (item, captionEl, isFake) {
            self.zoomCaption(item, captionEl, isFake);
          },
          getThumbBoundsFn: function getThumbBoundsFn() {
            const imageLocation = self.zoomWrappers[indexImage];
            const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            const rect = imageLocation.getBoundingClientRect();
            return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
          },
        };

        openPhotoSwipe(items, options);

        if (self.thumbsContainer && thumbs !== '') {
          self.thumbsContainer.innerHTML = thumbs;
        }
      }
    });
  }

  zoomCaption(item, captionEl, isFake) {
    let captionHtml = '';
    const targetContainer = captionEl.children[0];
    if (this.zoomCaptionElem) {
      captionHtml = this.zoomCaptionElem.innerHTML;

      if (this.zoomCaptionElem.closest(`.${classes.variantSoldOut}`)) {
        targetContainer.classList.add(classes.variantSoldOut);
      } else {
        targetContainer.classList.remove(classes.variantSoldOut);
      }

      if (this.zoomCaptionElem.closest(`.${classes.variantUnavailable}`)) {
        targetContainer.classList.add(classes.variantUnavailable);
      } else {
        targetContainer.classList.remove(classes.variantUnavailable);
      }
    }

    targetContainer.innerHTML = captionHtml;
    return false;
  }
}

export default Zoom;
